module.exports = __webpack_public_path__ + "static/media/messages-active.67a5ce10.svg";